import Warning from '@mui/icons-material/Warning';

import { useCommandBarAllValues } from '#components/command-bar/command-bar-context.js';
import { useCommandBarStore } from '#components/command-bar/command-bar-store.js';
import { PACKAGE_SEARCH_PREFIX, PACKAGE_SEARCH_PROVIDER_ID } from './package-search-types.js';

/** Empty message component for the package search provider. */
export function PackageSearchEmptyMessage() {
	const search = useCommandBarStore((s) => s.search);
	const providers = useCommandBarAllValues('providers');

	const shouldShow = search.startsWith(PACKAGE_SEARCH_PREFIX);
	const isProviderAvailable = providers.some((p) => p.id === PACKAGE_SEARCH_PROVIDER_ID);

	if (!shouldShow) {
		return null;
	}

	if (!isProviderAvailable) {
		return (
			<span className='flex items-center gap-2 text-amber-a12'>
				<Warning className='text-amber-10' />
				Package search is not available
			</span>
		);
	}

	return 'Enter a package family name or part number to search';
}
